var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33859 9.55334V9.13879C4.33859 4.92 7.76231 1.5 11.9857 1.5C16.209 1.5 19.6328 4.92 19.6328 9.13879V9.55334M4.33859 9.55334H4.16588C2.39797 9.55334 1 11.0236 1 12.7931C1 14.5627 2.39797 16.0329 4.16588 16.0329H4.37656C4.76297 19.5121 8.0501 22.5 11.9857 22.5C15.9212 22.5 19.2084 19.5121 19.5948 16.0329H19.8341C21.602 16.0329 23 14.5627 23 12.7931C23 11.0236 21.602 9.55334 19.8341 9.55334H19.6328M4.33859 9.55334V16.0329M19.6328 9.55334V16.0329M15.3209 17.5013C14.8593 18.8991 13.4556 19.8554 11.8641 19.8554C10.8902 19.8554 9.9956 19.5002 9.33856 18.9096M11.1009 13.6284C10.6118 14.2875 10.9456 15.552 11.8641 15.7691M16.5102 7.47632C15.748 6.44461 14.0938 6.49374 13.248 7.25287M7.69831 6.31628C8.46045 5.49494 10.1147 5.53405 10.9604 6.13839M10.6118 10.5492C10.6118 8.47672 8.02994 8.47672 8.02994 10.5492C8.02994 12.5152 10.6118 12.5152 10.6118 10.5492ZM15.8477 10.5492C15.8477 8.47672 13.2659 8.47672 13.2659 10.5492C13.2659 12.5316 15.8477 12.5316 15.8477 10.5492Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.75e9a35b30f52dc22b7aa66c00c03c7c.svg";
export { ForwardRef as ReactComponent };